import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';

class SheldonGmaInspect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      email: '',
      type: '',
      path: '',
      content: '',
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleButtonClick(type, event) {
    event.preventDefault();

    let { username, email } = this.state;
    let { hostInfo } = this.props;
    let { ip } = hostInfo;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let kskapi = Util.getKskApiPath(hostInfo);

    let path = '';
    let method = 'GET';
    switch (type) {
      case 'gmainspect':
        path = `${kskapi}/ksk/gmainspect?username=${username}&email=${email}`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    $.ajax({ url: path, dataType: 'json', method: method })
      .always((arg) => {
        this.inProgress = false;
      })
      .done((data) => {
        this.setState({
          content: <JsonView title={path} data={data} />,
        });
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  render() {
    let { panelHeight } = this.props;
    let { username, email, type } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>GMA Inspect</h2>
        <div style={{ margin: '20px 0' }}>For looking up GMA account info in kiosk.</div>
        <div className='sheldon-buttons'>
          <form className='pure-u-2-3 pure-form'>
            <fieldset>
              {/*<label style={{marginRight: 10}}>Enter username or email:</label>*/}
              <input
                className='pure-input-1-5'
                style={{ marginRight: 5 }}
                type='text'
                placeholder='username'
                value={username}
                onChange={(event) => this.setState({ username: event.target.value })}
              />
              <span style={{ marginRight: 5 }}>OR</span>
              <input
                className='pure-input-1-3'
                style={{ marginRight: 5 }}
                type='text'
                placeholder='email'
                value={email}
                onChange={(event) => this.setState({ email: event.target.value })}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleButtonClick.bind(this, 'gmainspect')}
              >
                Inspect
              </button>
            </fieldset>
          </form>
{/*
          <div className="pure-u-1-3">
            <span style={{paddingRight: 10}}>View Info:</span>
            <button className={type == 'kskcfg' ? 'pure-button pure-button__selected' : 'pure-button'}
                    onClick={this.handleButtonClick.bind(this, 'kskcfg')}>
              kskcfg
            </button>
          </div>
*/}
        </div>
        <div className='sheldon-content'>
          <div style={{ height: panelHeight - 280, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonGmaInspect;



// WEBPACK FOOTER //
// ./src/components/SheldonGmaInspect.js